export { default } from "./table.inner.container";
